import React from 'react';

export type BadgeVariant = 'success' | 'danger' | 'warning' | 'info' | 'neutral';

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  className?: string;
}

const variantClasses: Record<BadgeVariant, string> = {
  success: 'bg-semantic-success/15 text-semantic-success',
  danger:  'bg-semantic-danger/15  text-semantic-danger',
  warning: 'bg-brand-orange/15     text-brand-orange',
  info:    'bg-brand-blue/15       text-brand-blue',
  neutral: 'bg-border-neutral      text-text-muted',
};

export function Badge({ variant = 'neutral', children, className = '' }: BadgeProps) {
  return (
    <span
      className={[
        'inline-flex items-center px-2 py-0.5 rounded-full',
        'text-[11px] font-extrabold uppercase tracking-wide font-nunito',
        variantClasses[variant],
        className,
      ].join(' ')}
    >
      {children}
    </span>
  );
}
